import React from 'react';
import {
  Card,
  CardContent,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import messages from '../../messages.js';
import { useIntl } from 'react-intl';

export default function ValidationErrors({ errors = {} }) {
  const entries = Object.entries(errors);
  const intl = useIntl();

  if (entries.length === 0 || !Array.isArray(entries[0][1])) {
    return null;
  }

  return (
    <Card
      style={{ border: '1px solid #f44336', margin: '20px', overflow: 'auto' }}
    >
      <CardContent>
        <Typography
          variant="h5"
          style={{
            color: '#f44336',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
          }}
        >
          <ErrorOutlineIcon style={{ marginRight: '8px' }} />
          {intl.formatMessage(messages.csv_validation_errors_header)}
        </Typography>
        <Divider style={{ marginBottom: '8px' }} />
        <List dense>
          {entries.map(([key, value]) => (
            <ListItem
              key={key}
              style={{ flexDirection: 'column', alignItems: 'flex-start' }}
            >
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {key}
              </Typography>
              {value.map((v) => (
                <ListItemText
                  primary={v}
                  primaryTypographyProps={{ style: { color: '#f44336' } }}
                />
              ))}
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
